export default {
	"home":"Inicio",
	"userProfile":"Perfil del usuario",
	"shop":"tienda",
	"productDetails": "detalles del producto",
	"cart": "Carrito",
	"checkout":"Revisa",
	"payment":"Pago",
	"fashion":"Moda",
	"gadgets":"Gadgets",
	"accessories":"Accesorios",
	"categories":"Categorías",
	"men":"Hombres",
	"jean":"Vaquero",
	"jackets":"Chaquetas",
	"shirt":"Camisa",
	"tShirt":"Camiseta",
	"women":"Mujer",
	"dress":"Vestido",
	"dresses": "Vestidos",
	"headphone":"Auricular",
	"smartphone":"Smartphone",
	"watch":"Reloj",
	"speaker":"Altavoz",
	"laptopAccessories":"Accesorios para laptop",
	"belts":"Cinturones",
	"jewellery":"Joyería",
	"purse":"Bolso",
	"pages":"Páginas",
	"about":"Acerca de",
	"termAndCondition":"Término y condición",
	"privacyPolicy":"Política de privacidad",
	"blogDetail":"Detalle del blog",
	"faq":"Preguntas más frecuentes",
	"Page":"Página",
	"404Page":'Página 404',
	"session":"Sesión",
	"signIn":"Iniciar sesión",
	"adminSignIn":"Admin login",
	"register":"Registro",
	"forgotPassword":"Se te olvidó tu contraseña",
	"thankYou":"Gracias",
	"contactUs":"Contáctenos",
	"promotions":"Promociones",
	"reservations":"Reservaciones",
	"shops":"Locales",
	"social":"Social",
	"facebook":"Facebook",
	"twitter":"Twitter",
	"youtube":"Youtube",
	"googlePlus":"Google Mas",
	"reports":"Reportes",
	"dashboard":"Dashboard",
	"management":"Administración",
	"salons":"Pisos",
	"shifts":"Turnos",
	"rates":"Tarifas",
	"rooms":"Habitaciones",
	"roomTypes":"Tipos de Habitación",
	'lodgings': "Alojamiento",
	'reception': "Recepción",
	'roomsInUse': "Hab. Ocupadas",
	"unitTypes":"Unidades de Medida",
	"menu":"Productos / Servicios",
	"movements":"Movimientos",
	"inventories":"Inventario",
	"delivery":"Delivery",
	"orders":"Pedidos",
	"ordersOnline":"Pedidos online",
	"newOrder":"Nuevo Pedido",
	"list":"Listado",

	"sales":"Ventas",
	"newSale":"Nueva Venta",
	"customers":"Clientes",
	"rentals":"Alquileres",
	"documents":"Comprobantes",
	"debt":"Por cobrar",
	"summaries":"Resúmenes",
	"voided":"Anulaciones",
	"inventory":"Inventario",
	"warehouses":"Almacenes",
	"profile":"Perfil",
	"pos":"Punto de Venta",
	"products":"Productos",
	"productAdd":"Producto añadido",
	"goToSite":"Ir al sitio",
	"adminPanel":"Panel de administrador",
	"edit": "editar",
	
	"cash": "Caja",
	"cashManage": "Gestión de caja",
	"openings": "Apertura & cierre",
	"salesReceivables": "Cobrar",
	"openingsHistory": "Historial",

	"cleaningReport": "Limpieza",
	"reasonTravel": "Motivos de viaje",

	"configuration": "Configuración",
	"usersManage": "Gestión de usuarios",
	"permissions": "Permisos",
	"roles": "Roles",
	"users": "Usuarios",
	"CleaningPersonnel": "Personal de Limpieza",
	
	"tasks": "Tareas Programadas",
	"correlatives": "Correlativos",
	"establishments": "Establecimientos",
	"configurations": "Configuraciones",
	"distributionAreas": "Zonas de reparto",
	"settings": "Ajustes",
}